import React, { Component } from "react";
import { Button, Popover, Position } from "@blueprintjs/core";
import { observable, action } from "mobx";
import { observer, inject } from "mobx-react";
import SearchDateRangePicker from "components/SearchDateRangePicker";
import moment from "moment-timezone";
import { formatDateRange } from "helpers/dateRange";
import TechnicianPicker from "components/TechnicianPicker";
import NewVacationModal from "components/User/NewVacationModal";
import SearchFiltersToolbar from "components/SearchFiltersToolbar";
import SearchFiltersSearchButton from "components/SearchFiltersSearchButton";

@inject("store", "userStore", "viewStore")
@observer
class Vacations extends Component {
  @observable isOpenVacationModal = false;

  @action
  onDateRangeChange(range) {
    let {
      props: {
        viewStore: { vacationsSearch },
      },
    } = this;
    const rangeStart = moment(range[0]).startOf("day").toISOString();
    const rangeEnd = moment(range[1]).endOf("day").toISOString();
    this.props.viewStore.vacationsSearch = {
      ...vacationsSearch,
      rangeStart,
      rangeEnd,
      where: {
        ...vacationsSearch.where,
        // Match where the start_date is within the selected range, or end_date is within the selected range
        _or: [
          {
            start_date: {
              gte: rangeStart,
              lte: rangeEnd,
            },
          },
          {
            end_date: {
              gte: rangeStart,
              lte: rangeEnd,
            },
          },
          {
            start_date: {
              lte: rangeStart,
            },
            end_date: {
              gte: rangeStart,
            },
          },
          {
            start_date: {
              lte: rangeEnd,
            },
            end_date: {
              gte: rangeEnd,
            },
          },
        ],
      },
    };
    this.search();
  }

  @action
  search() {
    let viewStore = this.props.viewStore;
    viewStore.vacationsSearch.page = 1;
    viewStore.usersVacations();
  }

  onTechnicianChange(technicians) {
    let selectedValues = technicians.map((status) => status.value);
    let {
      props: {
        viewStore: { vacationsSearch },
      },
    } = this;
    this.props.viewStore.vacationsSearch = {
      ...vacationsSearch,
      where: {
        ...vacationsSearch.where,
        user_id: selectedValues,
      },
    };
  }

  handleCloseVacationModal() {
    this.isOpenVacationModal = false;
  }

  render() {
    const {
      rangeStart: rangeStartISO,
      rangeEnd: rangeEndISO,
      where,
    } = this.props.viewStore.vacationsSearch;
    return (
      <SearchFiltersToolbar
        searchButton={
          <SearchFiltersSearchButton onClick={this.search.bind(this)} />
        }
        actions={
          <Button
            icon="plus"
            onClick={() => {
              this.isOpenVacationModal = true;
            }}
          >
            Add Vacation
          </Button>
        }
        navExtra={
          <NewVacationModal
            isOpen={this.isOpenVacationModal}
            onClose={this.handleCloseVacationModal.bind(this)}
          />
        }
      >
        <Popover
          minimal={true}
          content={
            <SearchDateRangePicker
              startDate={moment(rangeStartISO).toDate()}
              endDate={moment(rangeEndISO).toDate()}
              onChange={this.onDateRangeChange.bind(this)}
            />
          }
          position={Position.BOTTOM_LEFT}
          usePortal={true}
        >
          <Button
            className="filter-date"
            icon="calendar"
            rightIcon="caret-down"
            text={formatDateRange(rangeStartISO, rangeEndISO)}
          />
        </Popover>

        <TechnicianPicker
          selectedOptions={(where && where.user_id) || []}
          onChange={this.onTechnicianChange.bind(this)}
          showUser
          includeAdmins
        />
      </SearchFiltersToolbar>
    );
  }
}

export default Vacations;
